import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const Overlay = styled(Box)(({ theme }) => ({
  position: 'relative',
  backgroundImage: `url("https://res.cloudinary.com/ddhrdxc7d/image/upload/v1762971746/full-width_website_header_-_Home_Page_bynllc.jpg")`,
  backgroundSize: 'cover',
  backgroundPosition: 'center top', // ✅ start from top of image
  width: '100%',
  overflowX: 'hidden',

  // ✅ just enough space for the navbar (no big white gap)
  // marginTop: `calc(${theme.mixins.toolbar.minHeight}px + 10px)`,

  // ✅ allow the banner to show full image height (use viewport height instead of fixed px)
  minHeight: '70vh', // looks good on most displays, adjust to 65–80vh as needed

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',

  [theme.breakpoints.down('md')]: {
    minHeight: '55vh',
    marginTop: `calc(${theme.mixins.toolbar.minHeight}px + 5px)`,
  },

  '&::before': {
    content: '""',
    position: 'absolute',
    inset: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.35)',
    zIndex: 1,
  },
}));



const ContentBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  zIndex: 2,
  color: 'white',
  padding: theme.spacing(4),
  
  maxWidth: '500px',
  marginLeft: theme.spacing(4), // Add space from left edge
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(2),
  },
}));

const BannerImageHomePage = () => {
  return (
    <Overlay>
      <Grid container>
        <Grid item xs={12} md={6}>
          <ContentBox>
            <Typography variant="h3" fontWeight="bold" gutterBottom>
              Let Your Dreams <br /> Take Flight
            </Typography>
            <Typography variant="body1" gutterBottom>
              We're here to help you live in the home of your dreams.
              <br />
              Ready to start life in a new place?
            </Typography>
            <Button
              variant="contained"
              color="primary"
              component="a"
              href="https://digitalmortgage.candidcrm.com/Jet-HomeLoans/005fI000000hPWD&00DfI000004W7Ue"
              target="_blank"
              rel="noopener noreferrer"
              sx={{ mt: 3, px: 4 }}
            >
              Apply Now
            </Button>
          </ContentBox>
        </Grid>
      </Grid>
    </Overlay>
  );
};

export default BannerImageHomePage;
